export default [
  {
    path: '/main/oslogs',
    meta: {
      tag: 'os_logs',
      name: 'Logs OS',
      breadcrumb: 'Logs OS',
      menu: 'settings'
    },
    component: () => import(/* webpackChunkName: "os-logs" */ '@/views/main/settings/consults/os-logs/List.vue')
  }
]